// 密保卡验证
<template>
<div>
<div class="g-bd">
  <div class="m-tlt">登录前请先验证密保卡</div>
  <form class="m-form" ref="form">
    <form-item ref="ppcValidate">
   <ul class="m-ppc" id="ppc-holder">
     <li v-for="c,index in cards" ref="cards">
      <div class="ppc-up">
        <div class="up-tlt" :class="'tlt'+(index+1)">{{c}}</div>
      </div>
     <div class="ppc-input">
      <input type="text" maxlength="3" autocomplete="off" spellcheck="false" @input="clearError(index)" ></input>
    </div>
    </li>
    </ul>
    </form-item>
    <div class="m-btns g-pd">
      <urs-button enableTip="确定" @click="onSubmit" ref="submitBtn"></urs-button>
    </div>
  </form>
</div>
<div class="g-ft g-pd clearfix c-main">
  <a class="f-right" href="https://gj.reg.163.com/faq/p4.html?ct=21">密保卡无法使用？</a>
</div>
</div>
</template>

<script>
import reqProxy from '../util/request'
import util from '../util/util'
import code from '../util/codemapper'

let vfppcCode = {
  '412':"密保卡验证错误次数过多，请改天再试",
  '430':"此次登录不需要进行密保验证",
  '431':"请求错误，请您稍后再试",
  '492':"账号未绑定密保卡",
  '493':"验证码验证错误，请重新输入坐标对应数字",
  '494':"验证码验证错误，请重新输入坐标对应数字",
}

util.merge(vfppcCode, code);

export default {
  props: {
    options:Object
  },
  data () {
    return {
      cos: this.options.cos
    }
  },
  computed:{
    cards () {
      return this.cos.split(';')
    }
  },
  mounted () {
    window.Loading.loading = false;
  },
  methods: {
    clearError(index){
      this.$refs.cards[index].className = ''
    },
    // onFocus(){
    //   this.$refs.ppcValidate.setMsg('');
    // },
    onSubmit () {
      // 表单校验&组成参数
      let cards = this.$refs.cards;
      let ppcpwd = '';
      let flag = 1;
      for(var i=0;i<cards.length;i++){
        let value = cards[i].getElementsByTagName('input')[0].value;
        if(!/^\d{1,3}$/.test(value)){
          window.showError('请正确输入密保卡上对应的数字');
          //this.$refs.ppcValidate.setMsg('请正确输入密保卡上对应的数字');
          cards[i].className = 'error';
          flag = 0;
        }
        ppcpwd+=value;
      }
      if(!flag){
        return;
      }
      // 提交密保卡验证
      this.$refs.submitBtn.state = 'loading'

      let data = {
        cos: this.options.cos,
        ppcpwd: ppcpwd,
        un: this.options.un
      }
      reqProxy({
        url: '/vfppc',
        method: 'POST',
        contentType: 'application/x-www-form-urlencoded',
        data: data,
        success: (data)=>{
          // 校验成功
          // 回到登录且自动帮助用户登录
          this.$refs.submitBtn.state = 'enable'
          this.$emit('changeToLogin',{autoLogin:1})
        },
        error:(data)=>{
          this.$refs.submitBtn.state = 'enable'

          // 校验错误，服务器错误
          // 停留在当前界面，toast提示
          if(data.ret === '493' || data.ret === '494' || data.ret === '500' || data.ret === '501'){
            // 更新坐标
            if(!!data.cos){
              // 更新坐标
              this.cos = data.cos;
              // 清空输入框 @NOTE
              this.$refs.form.reset();
            }
            window.showError(vfppcCode[data.ret]);
            return;
          }
          if(data.ret === '401' && data.dt === '10'){
            data.ret='40110';
          }
          // 其他错误，均返回登录界面
          this.$emit('changeToLogin', {errMsg:vfppcCode[data.ret],ret:data.ret,un:this.options.un})
        }
      });

    },
  }
}
</script>

<style lang="scss">
ul.m-ppc{
  width: 6rem;
  margin:0 auto;
  li:first-child {
    margin-left: 0
  }
  >li{
    display: inline-block;
    margin-left: 0.6rem;
    width: 1.56rem;
    height: 2.36rem;
    border: 1px solid #cccccc;
    background-color: #ffffff;
    &.error{
      border-color: #fa5b5b;
    }
  }
  .ppc-up{
    position: relative;
    width: .9rem;
    height: 1.2rem;
    border-bottom: 1px solid #cccccc;
    margin: 0 auto;
    text-align: center;
    .up-tlt{
      height: 100%;
      padding-top: .15rem;
      box-sizing: border-box;
    }
    .tlt1{
      color: #3291e8;
    };
    .tlt2{
      color: #8372f4;
    };
    .tlt3{
      color: #4ac940;
    }
  }
  .ppc-input{
    height: 1.12rem;
    width: .5rem;
    margin: 0 auto;
    >input{
      display: block;
      width: 100%;
      height: 100%;
      border: none;
      background-color: none;
      font-size: 0.28rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// Verifyppc.vue?43181078